import Vue from 'vue';
import { Component, Watch } from 'vue-property-decorator';
import * as Store from '../../store';
import * as Access from '../../utils/access';

@Component
export default class Sidebar extends Vue {
    // eslint-disable-next-line class-methods-use-this
    created() {}

    // eslint-disable-next-line class-methods-use-this
    mounted() {}

    get isLoggedIn(): boolean {
        return Store.readLoggedInState(this.$store);
    }

    get loggedUser() {
        return Store.readLoggedInUser(this.$store);
    }

    get canSeeGeneralMenu(): boolean {
        return Access.canSeeGeneralMenu(this.loggedUser);
    }

    get canAccessStock(): boolean {
        return Access.canAccessStock(this.loggedUser);
    }

    get isStockOnly(): boolean {
        return Access.isStockOnly(this.loggedUser);
    }

    get sidebarOpen(): boolean {
        return Store.readSidebarOpen(this.$store);
    }

    closeSidebar() {
        Store.commitSidebarOpen(this.$store, false);
    }

    @Watch('$route')
    onRouteChange() {
        this.closeSidebar();
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/sidebar/index.ts